import React from 'react';
import './Highsionstability.css';

const cardData = [
  {
    title: 'High Precision & Stability',
    description: 'Our advanced double-platen structure ensures unmatched precision and stability.',
  },
  {
    title: 'Customized Solutions',
    description: 'Tailored solutions for different pallet sizes ensure optimal molding outcomes.',
  },
  {
    title: 'Easy Maintenance',
    description: 'Our movable platen lock mold system is designed for ease of maintenance.',
  },
];

const Highsionstability = () => {
  return (
    <div  className="container">
         <div className="highsion">
      {cardData.map((card, index) => (
        <div className="highsion-card" key={index}>
          <h1>{card.title}</h1>
          <p>{card.description}</p>
        </div>
      ))}
    </div>
    </div>
   
  );
};

export default Highsionstability;
